import { observer } from 'mobx-react-lite';
import Layout from '../Layout/Layout';
import { Box, Typography, Button, Grid, Paper } from '@mui/material';

import CategoryIcon from '@mui/icons-material/Category';
import TranslateIcon from '@mui/icons-material/Translate';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import BarChartIcon from '@mui/icons-material/BarChart';

import PeopleIcon from '@mui/icons-material/People';
import PaymentIcon from '@mui/icons-material/Payments';
import { useNavigate } from 'react-router-dom';

const HomePage = observer(() => {
    const navigate = useNavigate();
    const headerHeight = 100;

    const tools = [
    ];

    const drawerTools = [
    ];

    const cards = [
        {
            title: 'מילון',
            icon: <TranslateIcon fontSize="large" />,
            buttonText: 'מעבר למילון',
            path: '/dictionary',
        },
        {
            title: 'AI',
            icon: <SmartToyIcon fontSize="large" />,
            buttonText: 'מעבר ל-AI',
            path: '/ai',
        },
        {
            title: 'קטגוריות',
            icon: <CategoryIcon fontSize="large" />,
            buttonText: 'מעבר לקטגוריות',
            path: '/categories',
        },
        {
            title: 'תמלולים (אודיו)',
            icon: <VolumeUpIcon fontSize="large" />,
            buttonText: 'מעבר לאודיו',
            path: '/audio',
        },
        {
            title: 'משתמשים',
            icon: <PeopleIcon fontSize="large" />,
            buttonText: 'מעבר למשתמשים',
            path: '/customers',
        },
        {
            title: 'כיתות',
            icon: <PeopleIcon fontSize="large" />,
            buttonText: 'מעבר לכיתות',
            path: '/classroom',
        },
        {
            title: 'סיריאלים',
            icon: <VpnKeyIcon fontSize="large" />,
            buttonText: 'מעבר לסיריאלים',
            path: '/access-serial',
        },
        {
            title: 'סטטיסטיקות',
            icon: <BarChartIcon fontSize="large" />,
            buttonText: 'מעבר לסטטיסטיקות',
            path: '/statistics',
        },
        {
            title: 'PayPal',
            icon: <PaymentIcon fontSize="large" />,
            buttonText: 'מעבר ל-PayPal',
            path: '/test-paypal',
        },
    ];

    return (
        <div className="HomePage" dir="rtl">
            <Layout tools={tools} drawerTools={drawerTools}>
                <Box
                    sx={{
                        p: { xs: 2, md: 3 },
                        backgroundColor: '#f5f7fa',
                        height: `calc(100vh - ${headerHeight}px)`,
                        overflowY: { xs: 'visible', md: 'auto' },
                        flexGrow: 1,
                    }}
                >
                    {/* כותרת ותיאור */}
                    <Box sx={{ textAlign: 'center', mb: 3 }}>
                        <Typography variant="h4" gutterBottom fontWeight="bold">
                            ניהול המערכת - Lexillon
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            ברוכים הבאים לממשק הניהול של לקסילון. כאן תוכלו לנהל את המילון, הקטגוריות, המשתמשים והתכנים בקלות.
                        </Typography>
                    </Box>

                    {/* כרטיסים */}
                    <Grid container spacing={2}>
                        {cards.map((card, index) => (
                            <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                                <Paper
                                    elevation={3}
                                    sx={{
                                        p: 2,
                                        textAlign: 'center',
                                        transition: 'transform 0.3s ease',
                                        '&:hover': { transform: 'scale(1.03)' },
                                        borderRadius: 2,
                                        backgroundColor: 'white',
                                    }}
                                >
                                    {card.icon}
                                    <Typography variant="h6" mt={1.5} fontSize="1rem">
                                        {card.title}
                                    </Typography>
                                    <Button
                                        variant="outlined"
                                        fullWidth
                                        sx={{ mt: 1.5, fontSize: '0.875rem', py: 1 }}
                                        onClick={() => navigate(card.path)}
                                        startIcon={card.icon}
                                    >
                                        {card.buttonText}
                                    </Button>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Layout>
        </div>
    );
});

export default HomePage;
